import { SxProps, Theme } from '@mui/material/styles';

export const headerSx: SxProps<Theme> = {
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
  alignItems: 'center',
  '@media (max-width: 476px)': {
    flexDirection: 'column',
    alignItems: 'flex-start',
  },
};
